import { styled } from '@lessonup/ui-components';
import React from 'react';

export const InlineSvgText: React.FC<React.HTMLAttributes<HTMLSpanElement>> = styled.span`
  svg {
    height: 1em;
  }
`;
